import React from "react";
import "./iitjeecoaching.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../footer/Footer";
import mainImg from "../../Assets/faq/mainimg.png";
import dot from "../../Assets/faq/dot.png";
import clarity from "../../Assets/faq/clarity.png";
import practice from "../../Assets/faq/Practice.png";
import Revise from "../../Assets/faq/Revise well.png";
import selfStudy from "../../Assets/faq/Self-study.png";
import regular from "../../Assets/faq/regular.png";
import testPaper from "../../Assets/faq/test papers.png";
import sleep from "../../Assets/faq/sleep.png";
import eat from "../../Assets/faq/eat.png";
import calm from "../../Assets/faq/calm.png";
import { Link } from "react-router-dom";

import person from "../../Assets/testimonial/person.png";
import coma from "../../Assets/testimonial/coma.png";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { Helmet } from "react-helmet";
import Newnavbar from "../newNavbar/Newnavbar";
import LogoContact from "../logoContact/logoContact";
import { FaWhatsapp } from "react-icons/fa";
import Newenqire from "../Enquire Form/Newenqire";

export default function IitJeeCoaching() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Best IIT JEE Coaching Classes in Thane | Nayak's Tutorials</title>
        <meta
          name="title"
          content="Best IIT JEE Coaching Classes in Thane | Achieve Your Dream Rank"
        />
        <meta
          name="description"
          content="Join Thane's best IIT JEE coaching for comprehensive preparation. Our expert faculty and rigorous test series ensure you achieve your dream rank in JEE Main & Advanced."
        />
        {/* <link
          rel="canonical"
          href="https://nayakstutorials.com/eleven&Twelth/"
        /> */}

        {/* <script type="application/ld+json">
          {`{
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://nayakstutorials.com/"
            }, {
              "@type": "ListItem",
              "position": 2,
              "name": "11 & 12 coaching",
              "item": "https://nayakstutorials.com/eleven&Twelth/"
            }]
          }`}
        </script> */}
      </Helmet>
      {/* <Navbar /> */}

      <div className="wpfloat">
        <LogoContact />
        <Newnavbar />

        <div className="elevenTopDiv">
          <div className="breadcrumbNayak" style={{ marginBottom: "10px" }}>
            <a href="/">Home »</a>
            <a href="/">Our Offerings »</a>
            <a>College »</a>
            <a>IIT-JEE Coaching</a>
          </div>

          <div className="elevenMain">
            <div className="elevenLeftDiv">
              <img src={mainImg} />
            </div>
            <div className="elevenRightDiv">
              <h1>IIT-JEE Coaching in Thane</h1>
              <p>
                The <b>Joint Entrance Examination (IIT-JEE)</b> is one of the{" "}
                <b>most competitive engineering entrance exams in India</b>,
                designed for students aspiring to secure admission to{" "}
                <b>
                  IITs, NITs, IIITs, and other prestigious engineering colleges
                </b>
                . It is conducted in two stages:<br></br>
                <b>• JEE Mains</b> – The qualifying exam for{" "}
                <b>NITs, IIITs, and other centrally funded institutions</b>, and
                a prerequisite for JEE Advanced.<br></br>
                <b>• JEE Advanced</b> – The final step for admission into the{" "}
                <b>IITs and top engineering institutes in India</b>.<br></br>
                At Nayak’s Tutorials, we provide the best JEE classes in Thane,
                offering structured learning, expert faculty, and exclusive
                study materials to ensure students perform at their highest
                potential.<br></br>
                If you are looking for top IIT-JEE coaching in Thane, our
                offline coaching program is designed to help students build a
                strong foundation, improve speed and accuracy, and gain
                confidence for both JEE Mains & JEE Advanced.<br></br>
                <b>📞 Get the Best IIT-JEE Coaching in Thane!</b>
                <br></br>
                <b>
                  🔗 Enroll Now | 🔗 Contact Us | 🔗 Explore Our Centers | 🔗
                  View JEE Batch
                </b>
                <br></br>
              </p>
            </div>
          </div>
          <div className="ElevenSeconDiv">
            <h2>
              <b>JEE Batches at Nayak’s Tutorials, Thane</b>
            </h2>
            <p>
              At Nayak’s Tutorials, Thane, we offer dedicated JEE classes with
              structured batch options to cater to different learning
              preferences.
            </p>

            <p>
              <Link to="/ace-40-batch-for-iit-jee-integrated">
                • Regular Batch (40 Students)
              </Link>
              <br />
              <Link to="/g-10-plus-batch-for-iit-jee-integrated">
                • Premium Small Batch (15 Students)
              </Link>
            </p>
          </div>

          <div className="ElevenSeconDiv">
            <h2>Both batches include:</h2>
            <p>
              ✅ Expert faculty with years of JEE coaching experience<br></br>✅
              Regular mock tests & exam simulations<br></br>✅ Strategic time
              management & problem-solving techniques<br></br>✅ Offline
              coaching in Thane for maximum engagement<br></br>
              <b>📞 Secure Your Spot in the Best JEE Classes in Thane!</b>
              <br></br>
            </p>
          </div>

          <div className="ElevenSeconDiv">
            <h2>Key Features of Our IIT-JEE Classes in Thane:</h2>
            <p>
              ✔️ Structured 2-Year Course – Covers Class 11 & 12 syllabus along
              with JEE Mains & Advanced preparation<br></br>
              ✔️ Expert Faculty – Highly experienced JEE trainers with proven
              success records<br></br>
              ✔️ Concept-Based Learning – Focus on problem-solving techniques,
              shortcut methods, and application-based learning<br></br>
              ✔️ Separate Batches for Focused Learning – Choose from Regular
              Batch (40 students) or Premium Small Batch (10 students)<br></br>
              ✔️ Comprehensive Study Material – Topic-wise notes, practice
              sheets & previous years’ question papers<br></br>
              ✔️ Regular Mock Tests & Exam Simulations – Weekly, monthly, and
              full-length JEE pattern tests for time management & accuracy
              <br></br>
              ✔️ Doubt-Solving Sessions & Personalized Mentorship – Individual
              attention to address strengths & weaknesses<br></br>
              ✔️ Offline JEE Classes in Thane – Interactive classroom
              environment to boost engagement & understanding<br></br>
            </p>
          </div>

          <div id="landtestimonialmain" className="cbsetestimonial">
            <h3>
              <b>What Our Students Say</b>
            </h3>
            <div className="mainTestDiv" id="firstTestimonial">
              <div className="testimonialfirst">
                <div style={{ padding: "10px" }} className="testImgDiv">
                  <img src={person} alt="testimonial one" />
                </div>
              </div>
              <div className="testimonialsecond">
                <h5 className="TName">Student</h5>
                <p>
                  {" "}
                  The IIT-JEE classes at Nayak’s Tutorials in Thane gave me the
                  perfect balance of concept clarity and problem-solving
                  techniques. The faculty ensured that every topic was covered
                  in detail, and the regular mock tests helped me improve my
                  speed and accuracy. Thanks to their expert guidance, I cleared
                  JEE Mains with a great rank!
                </p>
              </div>
              <div className="testimonialthird">
                <img src={coma} />
              </div>
            </div>
            <div className="mainTestDiv" id="lastTestimonial">
              <div className="testimonialfirst">
                <div style={{ padding: "10px" }} className="testImgDiv">
                  <img src={person} alt="testimonial two" />
                </div>
              </div>
              <div className="testimonialsecond">
                <h5 className="TName">Student</h5>
                <p>
                  Joining Nayak’s Tutorials was the best decision for my IIT-JEE
                  preparation. The small batch size ensured I got individual
                  attention, and the doubt-solving sessions were a game changer.
                  The study material and structured approach made a huge
                  difference. I highly recommend it to anyone looking for the
                  best IIT coaching in Thane.
                </p>
              </div>
              <div className="testimonialthird">
                <img src={coma} />
              </div>
            </div>
            <div className="mainTestDiv" id="lastTestimonial">
              <div className="testimonialfirst">
                <div style={{ padding: "10px" }} className="testImgDiv">
                  <img src={person} alt="testimonial three" />
                </div>
              </div>
              <div className="testimonialsecond">
                <h5 className="TName">Student</h5>
                <p>
                  The 2-year integrated classroom course at Nayak’s Tutorials
                  helped me build a solid foundation in Physics, Chemistry, and
                  Mathematics. The teachers are extremely supportive, and the
                  interactive teaching style kept me engaged. Their mock tests
                  simulated the real JEE environment, making me more confident
                  for the exam.
                </p>
              </div>
              <div className="testimonialthird">
                <img src={coma} />
              </div>
            </div>
          </div>
        </div>

        <div className="elevenLastDiv">
          <h3 className="elevenFaq">Frequently Asked Questions (FAQs)</h3>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  1. How good are the IIT-JEE coaching centers in Thane?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                Thane has several IIT-JEE coaching centers, but Nayak’s
                Tutorials stands out due to its structured curriculum,
                experienced faculty, and result-oriented approach. Our coaching
                program includes conceptual learning, problem-solving
                techniques, regular mock tests, and personalized mentorship to
                ensure students excel in JEE Mains & JEE Advanced.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  2. What is the admission process for IIT-JEE coaching in
                  Thane?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                The admission process at Nayak’s Tutorials, Thane is simple and
                student-friendly: Fill out the inquiry form or contact us
                directly.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  3. What is the location of IIT-JEE coaching centers in Thane?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                Nayak’s Tutorials offers IIT-JEE coaching in Thane, conveniently
                located for students across the city.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  4. What study material is provided by IIT-JEE coaching
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                ✔️ Concept Notes for Physics, Chemistry & Mathematics<br></br>
                ✔️ Topic-wise Practice Sheets with solved examples<br></br>
                ✔️ Previous Years’ JEE Mains & Advanced Papers for thorough
                revision<br></br>
                ✔️ Shortcut Techniques & Problem-Solving Strategies<br></br>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <div className="ElevenSeconDiv">
            <h5>
              📞 Looking for the Best IIT-JEE Coaching in Thane? Join Nayak’s
              Tutorials Today!
            </h5>
          </div>
        </div>
        <Footer />
        <a href="https://wa.me/+917710010044" target="_blank">
          <div className="wpicon">
            <FaWhatsapp id="faWp" size={50} color="white" />
          </div>
        </a>
      </div>
    </>
  );
}
